export const path = "/hop-alerts";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "ALERTAS",
  section: "HOP",
  group: null,
  order: 1,
  roles: [
    "Authenticated",
    "hop",
    "hop-management",
  ],
};
